export * from "./base.component";




// WEBPACK FOOTER //
// ./src/app/core/base/index.ts